const STORAGE_KEY = "mapfre-devmode";

function readUrlDevMode(): boolean {
  // Primero probamos con la búsqueda normal
  let params = new URLSearchParams(window.location.search);

  // Si no hay nada, probamos dentro del hash
  if (![...params.keys()].length && window.location.hash.includes("?")) {
    const hashQuery = window.location.hash.split("?")[1];
    params = new URLSearchParams(hashQuery);
  }

  const devMode = params.get("devmode");
  const revision = params.get("revision");

  return (
    devMode === "true" || devMode === "1" || revision?.toLowerCase() === "si"
  );
}

function readSessionStorageDevMode(): boolean {
  return sessionStorage.getItem(STORAGE_KEY) === "true";
}

export default function isDevMode(): boolean {
  return readUrlDevMode() || readSessionStorageDevMode();
}

export function enableDevMode(): void {
  sessionStorage.setItem(STORAGE_KEY, "true");
  window.location.reload();
}

export function disableDevMode(): void {
  sessionStorage.removeItem(STORAGE_KEY);
  window.location.reload();
}

export function toggleDevMode(): boolean {
  const next = !isDevMode();
  if (next) {
    enableDevMode();
  } else {
    disableDevMode();
  }
  return next;
}

if (typeof window !== "undefined") {
  (window as any).enableDevMode = enableDevMode;
  (window as any).disableDevMode = disableDevMode;
  (window as any).toggleDevMode = toggleDevMode;
}
